
export const getDaysInMonth = (monthId, year) => {
  const monthIndex = monthId - 1;
  if (!monthId || !year) return 0;
  
  const monthsWith31Days = [1, 3, 5, 7, 8, 10, 12];
  const monthsWith30Days = [4, 6, 9, 11];
  
  if (monthsWith31Days.includes(monthId)) {
    return 31;
  } else if (monthsWith30Days.includes(monthId)) {
    return 30;
  } else if (monthId === 2) {
    const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    return isLeapYear ? 29 : 28;
  }
  
  return 0;
};

export const initializeAttendanceData = (data, month, year) => {
  // Filter RESUBMIT first
  const filteredData = data.some(item => item.status === "RESUBMIT")
    ? data.filter(item => item.status === "RESUBMIT")
    : data;

  return filteredData.map(item => {
    const daysInMonth = getDaysInMonth(month, year);
    const presentDays = item.presentDays || 0;
    const casualLeave = item.casualLeaveDays || item.casualLeave || 0;
    const daysAbsent =
      item.absentDays || item.daysAbsent || daysInMonth - (presentDays + casualLeave);

    return {
      ...item,
      id: item.id || null,
      attendanceId: item.attendanceId || null,
      presentDays,
      casualLeave,
      daysAbsent: daysAbsent < 0 ? 0 : daysAbsent,
      leaves: item.leaves || 0,
      locationName: item.locationName || "N/A",
      usedLeaves: item.usedLeaves || 0,
      originalUsedLeaves: item.usedLeaves || 0,
      mode: item.status === "RESUBMIT" ? "update" : "create",
    };
  });
};

// export const initializeAttendanceData = (data, month, year) => {
//   const hasResubmit = data.some(item => item.status === "RESUBMIT");

//   if (!hasResubmit) {
//     // Normal case
//     return data.map(item => ({
//       ...item,
//       id: item.id || null,
//       attendanceId: item.attendanceId || null,
//       presentDays: item.presentDays || 0,
//       casualLeave: item.casualLeaveDays || item.casualLeave || 0,
//       daysAbsent:
//         item.absentDays || item.daysAbsent || getDaysInMonth(month, year) -
//         ((item.presentDays || 0) + (item.casualLeaveDays || item.casualLeave || 0)),
//       leaves: item.leaves || 0,
//       usedLeaves: item.usedLeaves || 0,
//       originalUsedLeaves: item.usedLeaves || 0,
//       mode: "create",
//       designation: item.designation || "N/A",
//       fullName: item.fullName || "N/A",
//       godownNames: Array.isArray(item.godownNames)
//         ? item.godownNames.join(", ")
//         : item.godownNames || "N/A",
//     }));
//   }

//   // If RESUBMIT data exists:
//   const baseEmployees = data.filter(i => !i.status || i.status !== "RESUBMIT");
//   const resubmits = data.filter(i => i.status === "RESUBMIT");

//   // Merge resubmitted data with base info
//   const merged = baseEmployees.map(emp => {
//     const res = resubmits.find(r => r.employeeId === emp.employeeId);
//     return {
//       ...emp,
//       ...res, // overwrites attendance values but keeps name/designation
//     };
//   });

//   return merged.map(item => {
//     const daysInMonth = getDaysInMonth(month, year);
//     const presentDays = item.presentDays || 0;
//     const casualLeave = item.casualLeaveDays || item.casualLeave || 0;
//     const daysAbsent =
//       item.absentDays || item.daysAbsent || daysInMonth - (presentDays + casualLeave);

//     return {
//       ...item,
//       id: item.id || null,
//       attendanceId: item.attendanceId || null,
//       presentDays,
//       casualLeave,
//       daysAbsent: daysAbsent < 0 ? 0 : daysAbsent,
//       leaves: item.leaves || 0,
//       usedLeaves: item.usedLeaves || 0,
//       originalUsedLeaves: item.usedLeaves || 0,
//       mode: item.status === "RESUBMIT" ? "update" : "create",
//       designation: item.designation || "N/A",
//       fullName: item.fullName || "N/A",
//       godownNames: Array.isArray(item.godownNames)
//         ? item.godownNames.join(", ")
//         : item.godownNames || "N/A",
//     };
//   });
// };


export const initializePendingAttendance = (data, month, year) => {
  const getDaysInMonth = (month, year) => new Date(year, month, 0).getDate();

  return data.map((item) => {
    const daysInMonth = getDaysInMonth(month, year);
    const presentDays = item.presentDays || 0;
    const casualLeave = item.casualLeaveDays || item.casualLeave || 0;
    const daysAbsent =
      item.absentDays ||
      item.daysAbsent ||
      daysInMonth - (presentDays + casualLeave);

    return {
      ...item,
      presentDays,
      casualLeave,
      daysAbsent: daysAbsent < 0 ? 0 : daysAbsent,
      leaves: item.leaves || 0,
      locationName: item.locationName || "N/A",
      usedLeaves: item.usedLeaves || 0,
    };
  });
};


export const getAuditLog = () => ({
  name: localStorage.getItem("full_name"),
  role: localStorage.getItem("role"),
  employeeId: localStorage.getItem("employeeId"),
});

